import * as React from "react"
import { PageProps } from "gatsby"
import { MDXProvider } from "@mdx-js/react"

import { LegalContainer, LegalHeadline, LegalLayout } from "./styles"
import { DefaultGlobalStyle } from "../styles"
import NavigationComponent from "../../components/core/navigation"
import FooterComponent from "../../components/core/footer"
import SEOComponent from "../../components/core/seo"

export default function Legal(props: PageProps<any, { frontmatter: { title: string } }>) {
  return (
    <LegalLayout>
      <DefaultGlobalStyle/>
      <SEOComponent lang={props.pageContext["langKey"]} title={props.pageContext["frontmatter"].title}/>
      <NavigationComponent locale={props.pageContext["langKey"]}/>
      <LegalContainer>
        <LegalHeadline>{props.pageContext.frontmatter.title}</LegalHeadline>
        <MDXProvider>{props.children}</MDXProvider>
      </LegalContainer>
      <FooterComponent locale={props.pageContext["langKey"]}/>
    </LegalLayout>
  )
}
